import {
  getModule,
  Module,
  MutationAction,
  VuexModule
} from "vuex-module-decorators";
import store from "@/store";
import * as ShopAPI from "@/api/usen-manage";
import { CommonResponse, isSuccess } from "@/api/response";
import { DeleteRequest, RegisterRequest } from "@/api/usen-manage/request";

const MODULE_NAME = "shop/usen-manage";

/**
 * 店舗情報削除/登録更新APIのレスポンスを管理するストアモジュール
 */
@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class Modify extends VuexModule {
  // state
  commonResponse: CommonResponse = {} as CommonResponse;

  // getters
  get isSuccess() {
    return isSuccess(this.commonResponse);
  }

  get getMessage() {
    return this.commonResponse.message;
  }

  // MutationActions
  @MutationAction
  async deleteOne(deleteRequest: DeleteRequest) {
    const commonResponse = await ShopAPI.deleteOne(deleteRequest);
    return {
      commonResponse
    };
  }

  @MutationAction
  async register(registerRequest: RegisterRequest) {
    const commonResponse = await ShopAPI.register(registerRequest);
    return {
      commonResponse
    };
  }

  @MutationAction
  async clearResponse() {
    return {
      commonResponse: {} as CommonResponse
    };
  }
}

export default getModule(Modify);
